module.exports = __webpack_public_path__ + "img/people.4482a4b.svg?v=1747398688961";